// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1-0lz","image":"style_image__1jHZI","title":"style_title__3nWk-","info":"style_info__U6YFd"};